module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Regular.c3f8d68.otf";